import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { FormGroup } from '@angular/forms';
import Quill from 'quill';
import 'quill-mention';
import { CsTaggingService } from "@app/directives/material-directives/cs-tagging/cs-tagging.service";
var FontStyle = Quill.import('attributors/style/font');
FontStyle.whitelist = [
    'Arial, sans-serif',
    'Courier New, monospace',
    'Georgia, serif',
    'Tahoma, sans-serif',
    'Times New Roman, serif',
    'Trebuchet MS, sans-serif',
    'Verdana, sans-serif'
];
Quill.register(FontStyle, true);
var Size = Quill.import('attributors/style/size');
Size.whitelist = [false, '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px'];
Quill.register(Size, true);
var setDefaultCssProperties = function () {
    var Block = Quill.import("blots/block");
    var Pblock = /** @class */ (function (_super) {
        tslib_1.__extends(Pblock, _super);
        function Pblock() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Pblock.create = function (value) {
            var node = _super.create.call(this);
            node.setAttribute("style", "margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;");
            return node;
        };
        return Pblock;
    }(Block));
    Quill.register(Pblock, true);
};
var ɵ0 = setDefaultCssProperties;
setDefaultCssProperties();
/*
let Delta = Quill.import('delta');
let Break:any = Quill.import('blots/break');
const Embed = Quill.import('blots/embed');

const lineBreakMatcher = () => {
    let newDelta = new Delta();
    newDelta.insert({ break: "" });
    return newDelta;
};
class SmartBreak extends Break {
    length () {
        return 0
    }
    value () {
        return '\n'
    }
    insertInto(parent, ref) {
        Embed.prototype.insertInto.call(this, parent, ref)
    }
}

SmartBreak.blotName = 'break';
SmartBreak.tagName = 'BR';
Quill.register(SmartBreak)
*/
var QuillEditorCustomComponent = /** @class */ (function () {
    function QuillEditorCustomComponent(tagService) {
        this.tagService = tagService;
        // Dial Pad only - drives the exact same plain-text tag flow normally triggered by '[',
        // just keyed on '@' instead. Never true alongside opportunity_notes/opportunity_call_log/
        // scheduledActivities, which already use '@' for a different (chip-style mention) flow.
        this.dialPad = false;
        this.contentChanged = new EventEmitter();
        this.configureCustomData = new EventEmitter();
        this._tagsList = [];
        this.customTagList = [];
        this.csTaggingList = [];
        this.initialLoad = false;
        this.doNotShowLoading = false;
        this.placeHolder = 'To use tags, type \'[\' and choose from the list of tags';
    }
    Object.defineProperty(QuillEditorCustomComponent.prototype, "tagsList", {
        set: function (tags) {
            if (tags && tags.length) {
                this._tagsList = tags;
                if ($('.ql-mention-loading').length > 0) {
                    this.editors.quillEditor.getModule('mention').openMenu("");
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(QuillEditorCustomComponent.prototype, "customTagsList", {
        set: function (tags) {
            var _this = this;
            this.doNotShowLoading = false;
            if (tags.length) {
                this.customTagList = tags;
                if ($('.ql-mention-loading').length > 0) {
                    this.editors.quillEditor.getModule('mention').openMenu("");
                }
                var $mentionWrap = $('span.mention');
                tags.forEach(function (tag) {
                    if (tag.denotationChar === '{') {
                        if (!tag['value'].includes('{')) {
                            tag['value'] = '{' + tag['value'] + '}';
                        }
                        if (tag.new) {
                            _this.onSelectTagHandler(tag);
                            delete tag.new;
                        }
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(QuillEditorCustomComponent.prototype, "tagChar", {
        // Default/fallback tag-flow trigger char - '[' everywhere except Dial Pad, which uses '@'
        // for the identical flow.
        get: function () {
            return this.dialPad ? '@' : '[';
        },
        enumerable: true,
        configurable: true
    });
    QuillEditorCustomComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.screen === 'opportunity')
            this.screen = 'opportunity_notes';
        this.module = {
            mentionListClass: 'ql-mention-list mat-elevation-z8',
            defaultMenuOrientation: 'bottom',
            allowedChars: /^[A-Za-z0-9\sÅÄÖåäö\_\}\?]*$/,
            fixMentionsToQuill: false,
            showDenotationChar: false,
            spaceAfterInsert: this.screen === 'call_note_template' || this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities' ? true : false,
            isolateCharacter: false,
            selectKeys: [13, 221],
            renderItem: function (data) {
                if (data.disabled) {
                    return "<div style=\"background-color:#ddd;margin:0 -14px;padding:2px 8px; font-weight: bold; pointer-events: none; color:#999;\">" + data.value + "</div>";
                }
                else if (data.text) {
                    return data.text;
                }
                return data.value;
            },
            onSelect: function (item, insertItem) {
                if (item.denotationChar === _this.tagChar) {
                    item['value'] = '[' + item['value'] + ']';
                    _this.onSelectTagHandler(item);
                }
                if (_this.screen === 'call_note_template') {
                    if (item.denotationChar === '{') {
                        if (!_this.customTagList.length) {
                            _this.configureCustomData.emit(tslib_1.__assign({}, item, { action: 'add' }));
                        }
                        else {
                            var existingCt = _this.customTagList.find(function (ct) { return ct.value == item.value; });
                            if (!existingCt) {
                                _this.configureCustomData.emit(tslib_1.__assign({}, item, { action: 'add' }));
                            }
                            else {
                                _this.onSelectTagHandler(item);
                            }
                        }
                    }
                }
                else if (_this.screen === 'opportunity_notes' || _this.screen === 'opportunity_call_log' || _this.screen == 'scheduledActivities') {
                    item['value'] = item['value'];
                    _this.onSelectTagHandler(item);
                }
            },
            renderLoading: function (data) {
                if (!_this.customTagList.length || _this.doNotShowLoading) {
                    return;
                }
                return "Loading...";
            },
            mentionDenotationChars: this.screen === 'call_note_template' ? ['{'] : (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities') ? ['@'] : [this.tagChar],
            source: function (searchTerm, renderList, mentionChar) {
                var values = [];
                if (mentionChar == _this.tagChar) {
                    if (searchTerm.length === 0) {
                        values = _this._tagsList;
                    }
                    else {
                        var matches = [];
                        values = _this._tagsList;
                        for (var i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            values.push({
                                id: 0,
                                value: "No tag found...",
                                disabled: true
                            });
                        }
                    }
                    if (values.length) {
                        renderList(values, searchTerm);
                    }
                }
                else if (mentionChar == '{' && _this.screen === 'call_note_template') {
                    if (searchTerm.length === 0) {
                        values = _this.customTagList;
                    }
                    else {
                        var matches = [];
                        values = _this.customTagList;
                        for (var i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            if (searchTerm.includes('}')) {
                                var name_1 = searchTerm.slice(0, searchTerm.length - 1);
                                _this.doNotShowLoading = true;
                                _this.configureCustomData.emit({ name: name_1, denotationChar: '{', value: name_1, action: 'add' });
                            }
                            else {
                                values.push({
                                    id: 0,
                                    text: "Press enter to add new custom tag",
                                    value: searchTerm
                                });
                            }
                        }
                    }
                    renderList(values, searchTerm);
                }
                else if (mentionChar == '@' && (_this.screen === 'opportunity_notes' || _this.screen === 'opportunity_call_log' || _this.screen == 'scheduledActivities')) {
                    if (searchTerm.length === 0) {
                        values = _this._tagsList;
                    }
                    else {
                        var matches = [];
                        values = _this._tagsList;
                        for (var i = 0; i < values.length; i++) {
                            if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                                matches.push(values[i]);
                            }
                        }
                        values = matches;
                        if (matches.length === 0) {
                            values.push({
                                id: 0,
                                value: "No values found...",
                                disabled: true
                            });
                        }
                    }
                    if (values.length) {
                        renderList(values, searchTerm);
                    }
                }
            }
        };
        this.modulesMessage = {
            mention: this.module,
            /*clipboard: {
                 matchers: [
                     ['BR', lineBreakMatcher]
                 ],
                // matchVisual: true,
             },
             keyboard: {
                 bindings: {
                     linebreak: {
                         key: 13,
                         shiftKey: true,

                         handler: function (range) {
                             let currentLeaf = this.quill.getLeaf(range.index)[0]
                             let nextLeaf = this.quill.getLeaf(range.index + 1)[0];
                             this.quill.insertEmbed(range.index, "break", true, "user");
                             if (nextLeaf === null || currentLeaf.parent !== nextLeaf.parent) {
                                 this.quill.insertEmbed(range.index, "break", true, "user");
                             }
                             // Now that we've inserted a line break, move the cursor forward
                             this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
                         }
                     }
                 }
             },*/
            toolbar: {
                container: [
                    ['bold', 'italic', 'underline'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ font: [
                                'Arial, sans-serif',
                                'Courier New, monospace',
                                'Georgia, serif',
                                'Tahoma, sans-serif',
                                'Times New Roman, serif',
                                'Trebuchet MS, sans-serif',
                                'Verdana, sans-serif'
                            ] }],
                    [{ size: [false, '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px'] }],
                    ['link']
                ]
            }
        };
        this.modulesSubject = {
            mention: this.module,
            toolbar: false
        };
        if (this.uploadCommunication) {
            this.uploadCommunication.subscribe(function (data) {
                if (data === 'sms' || _this.lableName === 'subject') {
                    _this.initialLoad = true;
                }
                _this.communicatioType = data;
            });
        }
        window.addEventListener('mention-clicked', function (event) {
            var editableCT = _this.customTagList.find(function (ctl) { return ctl.value == event.value.value; });
            _this.configureCustomData.emit(tslib_1.__assign({}, editableCT, { action: 'edit', denotationChar: '{' }));
        }, false);
        if (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'scheduledActivities') {
            this.modulesMessage['toolbar'] = false;
            this.modulesMessage['keyboard'] = {
                bindings: {
                    bold: null,
                    italic: null,
                    underline: null,
                    strike: null,
                    blockquote: null,
                    header: null,
                    list: null,
                    indent: null
                }
            };
            this.placeHolder = 'To mention a user, type \'@\' and choose from the list of users';
        }
        else if (this.screen === 'communication_notes') {
            this.modulesMessage['toolbar'] = false;
            this.placeHolder = '';
        }
        else if (this.screen === 'call_note_template') {
            this.placeHolder = 'To create custom tags, type \'{\' and type your tag name and press enter';
        }
        else if (this.dialPad) {
            this.placeHolder = 'To use tags, type \'@\' and choose from the list of tags';
        }
        document.addEventListener('click', this.handleCellClick.bind(this));
    };
    QuillEditorCustomComponent.prototype.onSelectTagHandler = function (item) {
        var _this = this;
        var denotationChar = item.denotationChar;
        this.editors.quillEditor.getModule('mention').insertItem(item, false);
        item.denotationChar = denotationChar;
        if (denotationChar === this.tagChar) {
            setTimeout(function () {
                var $mentionSpan = $('span.mention > span');
                var $mentionWrap = $('span.mention:not(.custom_tag)');
                _this.editors.quillEditor.insertText(_this.editors.quillEditor.getSelection(true), item.value + ' ');
                if ($mentionSpan.length > 0) {
                    $mentionWrap.remove();
                    setTimeout(function () {
                        var curPos = _this.editors.quillEditor.getSelection(true);
                        _this.editors.quillEditor.setSelection(curPos, -1);
                    }, 0);
                }
            }, 300);
        }
        else if (denotationChar === '{' && this.screen === 'call_note_template') {
            setTimeout(function () {
                var $mentionSpan = $('span.mention > span');
                var $mentionWrap = $('span.mention');
                if ($mentionSpan.length > 0) {
                    $mentionWrap.addClass('custom_tag');
                    setTimeout(function () {
                        var curPos = _this.editors.quillEditor.getSelection(true);
                        _this.editors.quillEditor.setSelection(curPos, -1);
                    }, 0);
                }
            }, 300);
        }
        else if (denotationChar === '@') {
            setTimeout(function () {
                var $mentionSpan = $('span.mention > span');
                var $mentionWrap = $('span.mention');
                $('span.mention').find('.ql-mention-denotation-char').remove();
                if ($mentionSpan.length > 0) {
                    $mentionWrap.addClass('user-style user-notes');
                    $mentionWrap.children().addClass('user-name');
                    var closeSection = $('<span></span>').addClass('close-icon');
                    var hasCloseIcon = $mentionWrap.find('.close-icon');
                    if ($mentionWrap.length == 1) {
                        if (hasCloseIcon.length == 0) {
                            $mentionWrap.children().append(closeSection);
                        }
                    }
                    else {
                        for (var i = 0; i < $mentionWrap.length; i++) {
                            var $element = $($mentionWrap[i]);
                            var hasCloseIcon_1 = $element.find('.close-icon');
                            if (hasCloseIcon_1.length == 0) {
                                $element.children().append(closeSection);
                            }
                        }
                    }
                    setTimeout(function () {
                        var curPos = _this.editors.quillEditor.getSelection(true);
                        _this.editors.quillEditor.setSelection(curPos, -1);
                    }, 0);
                }
            });
        }
    };
    QuillEditorCustomComponent.prototype.blurHandler = function ($event) {
        var el = document.querySelector('.ql-tooltip [data-link]');
        if (!el) {
            return;
        }
        el.setAttribute('placeholder', 'http(s)://example.com');
        el.setAttribute('data-link', '');
    };
    QuillEditorCustomComponent.prototype.onContentChanged = function (event) {
        this.contentChanged.emit(event);
        this.editorCreated(event);
    };
    QuillEditorCustomComponent.prototype.editorCreated = function (event) {
        if (this.screen === 'call_note_template') {
            var $mentionWrap = $('span.mention:not(.custom_tag)');
            $mentionWrap.addClass('custom_tag');
        }
        else if (this.screen === 'opportunity_notes' || this.screen === 'opportunity_call_log' || this.screen == 'opportunity' || this.screen == 'scheduledActivities' || this.screen == 'customer') {
            var $mentionWrapCT = $('span.mention[data-value^="{"]');
            $mentionWrapCT.addClass('custom_tag');
            var mentionWrapUN = $('span.mention');
            mentionWrapUN.addClass('user-style user-notes');
            mentionWrapUN.children().addClass('user-name');
            if (mentionWrapUN.length === 1) {
                var $singleMention = mentionWrapUN.eq(0);
                var hasCloseIcon = mentionWrapUN.find('.close-icon');
                if ($singleMention.find('.close-icon').length == 0) {
                    var closeSection = $('<span></span>').addClass('close-icon');
                    mentionWrapUN.children().append(closeSection);
                }
            }
            else {
                for (var i = 0; i < mentionWrapUN.length; i++) {
                    var $element = $(mentionWrapUN[i]);
                    var hasCloseIcon = $element.find('.close-icon');
                    if (hasCloseIcon.length === 0) {
                        var closeSection = $('<span></span>').addClass('close-icon');
                        $element.children().append(closeSection);
                    }
                }
            }
        }
    };
    QuillEditorCustomComponent.prototype.handleCellClick = function (event) {
        var mentionElement = event.target.closest('.mention');
        if (mentionElement) {
            mentionElement.remove();
        }
    };
    return QuillEditorCustomComponent;
}());
export { QuillEditorCustomComponent };
export { ɵ0 };
